import React from 'react'
import PropTypes from 'prop-types'

const BLUR_DELAY = 1000
const DEFAULT_TITLE = 'Select'

class MultiSelect extends React.Component {
    constructor (props) {
        super(props)
        const { toggleColumnVisibility } = props;
        this.toggleColumnVisibility = toggleColumnVisibility;
        this.state = {
            open: false
        }
        this.toggleOpenClose = this.toggleOpenClose.bind(this)
        this.handleBlur = this.handleBlur.bind(this)
        this.handleClose = this.handleClose.bind(this)
    }

    blurTimeout = null

    toggleOpenClose (event) {
        this.setState({open: !this.state.open})
    }

    handleClose (event) {
        this.setState({open: false})
    }

    getOptionClickHandler (option) {
        return ((event) => {
            this.handleOptionClick(event, option)
        })
    }

    getResetClickHandler () {
        return ((event) => {
            this.handleResetClick(event)
        })
    }

    handleOptionClick (event, option) {
        option.checked = !option.checked
        this.toggleColumnVisibility(option.name)
        this.handleFocus()
        this.forceUpdate()
    }

    handleResetClick (event) {
        this.props.options.forEach((option) => {
            if (!option.checked) {
                option.checked = true
                this.toggleColumnVisibility(option.name)
            }
        })
        this.handleFocus()
        this.forceUpdate()
    }

    handleFocus () {
        clearTimeout(this.blurTimeout)
    }

    handleBlur () {
        clearTimeout(this.blurTimeout)
        this.blurTimeout = setTimeout(this.handleClose, BLUR_DELAY)
    };

    render () {
        const { title = DEFAULT_TITLE } = this.props

        return (
            <div className="multi-selector-container">
                <button className="multi-selector-button"
                        onClick={this.toggleOpenClose}
                        onBlur={this.handleBlur}>
                    <div className="multi-selector-label">{title}</div>
                </button>
                {this.renderOptions()}
            </div>
        )
    }

    renderOptions () {
        const { options } = this.props
        const { open } = this.state
        let optionsClassName = 'multi-selector-options'
        if (!open) {
            optionsClassName += ' multi-selector-hidden'
        }
        let optionKey = 0
        return (<div className={optionsClassName}>
            <div className="multi-selector-off-screen">
                {options.map(option => (
                    <a key={"option_" + optionKey++}
                       className={"multi-selector-option" + (option.checked ? " multi-selector-option-selected" : "" ) }
                       onClick={this.getOptionClickHandler(option)}
                    >{option.title}</a>)
                )}
            </div>
            <button className="multi-selector-reset" onClick={this.getResetClickHandler()}>Reset options</button>
        </div>)
    }
}


MultiSelect.propTypes = {
    title: PropTypes.string,
    options: PropTypes.array.isRequired,
}

export default MultiSelect



// WEBPACK FOOTER //
// ./src/modules/form/component/MultiSelect.js